import Phaser from 'phaser';
import { LoadingScene, CloudTowerScene } from './scenes';

export class CloudTowerGame {
  private game: Phaser.Game;

  constructor(container: HTMLElement) {
    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      width: window.innerWidth,  // 9:16 ratio (portrait)
      height: window.innerHeight, // 9:16 ratio (portrait)
      parent: container,
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: 1080,
        height: 1920
      },
      physics: {
        default: 'arcade',
        arcade: {
          gravity: { y: 1200, x: 0 }, // Tăng gravity cho màn hình cao hơn
          debug: false
        }
      },
      scene: [LoadingScene, CloudTowerScene]
    };

    this.game = new Phaser.Game(config);
  }

  destroy(): void {
    if (this.game) {
      this.game.destroy(true);
    }
  }
}
